import { ref } from 'vue';
import { $fetch } from 'ofetch';
import type Stripe from 'stripe';

/*
 * Wrapper around a plain $fetch request so that this utility can be used from
 * anywhere in the codebase (e.g. Pinia stores, composables, or components)
 * without relying on Nuxt-specific composables such as `useFetch`, which
 * require an active Nuxt context. The function mimics the subset of the
 * `useFetch` return signature that our callers expect – namely an object
 * containing `data` and `error` refs – so no calling code needs to change.
 */
export const getStripeSubscription = async (stripeSubscriptionId: string) => {
  const data = ref<Stripe.Response<Stripe.Subscription & { plan: Stripe.Plan }> | null>(null);
  const error = ref<any>(null);

  try {
    const baseUrl =
      typeof window !== 'undefined'
        ? window.location.origin
        : process.env.NUXT_PUBLIC_BASE_URL || process.env.BASE_URL || 'http://localhost:3000';

    const res = await $fetch<{
      data: Stripe.Response<Stripe.Subscription & { plan: Stripe.Plan }> | null;
      error: any;
    }>(`${baseUrl}/api/stripe/subscriptions/${stripeSubscriptionId}`);

    data.value = res?.data ?? null;
  } catch (e) {
    console.error(e);
    error.value = e;
  }

  return { data, error };
};
